// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1VxRE","fullScreen":"style_fullScreen__3QqH-","hidden":"style_hidden__zy16d"};